const STORAGE_KEY = 'coaching_widget'

function getCoachingWidgetStorage() {
  return JSON.parse(window.localStorage.getItem(STORAGE_KEY))
}

function setCoachingWidgetStorage(widgetState) {
  let currStorage = {}
  const storageStr = getCoachingWidgetStorage()

  if (storageStr != null) {
    currStorage = storageStr
  }

  window.localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify(
      {
        ...currStorage,
        ...widgetState
      }
    )
  )
}

export const getCoachingWidgetStorageCollapsed = () => {
  const storage = getCoachingWidgetStorage()

  if (storage == null) {
    return false
  }

  return storage.collapsed
}

export const setStorageCoachingWidgetStorageCollapsed = (isCollapsed) => {
  setCoachingWidgetStorage({
    collapsed: isCollapsed,
  })
}



// WEBPACK FOOTER //
// ./src/utils/coachingWidget.storage.js